export type SourceComboboxItems = {
  /** Trimmed search input. Use this as the value when offering "Add '…'". */
  trimmedSearch: string;
  /** Options to render in the suggestion list (case-insensitive substring of trimmedSearch). */
  filteredOptions: string[];
  /** Whether to offer an "Add '<trimmedSearch>'" affordance. */
  canCreate: boolean;
};

/**
 * Derive the suggestion list and create-affordance for the Source combobox.
 *
 * Filtering and the duplicate check share the *trimmed* search so whitespace
 * input (e.g. " Ovation") can't simultaneously filter out the existing match
 * and be suppressed as a duplicate, which would dead-end the UI with neither
 * a selectable option nor an "Add" action.
 */
export function computeSourceComboboxItems(
  search: string,
  options: string[],
): SourceComboboxItems {
  const trimmedSearch = search.trim();
  const searchLower = trimmedSearch.toLowerCase();

  // Preserve the input reference when there's no search so useMemo consumers
  // don't see a new array on every keystroke.
  const filteredOptions = !trimmedSearch
    ? options
    : options.filter((opt) => opt.toLowerCase().includes(searchLower));

  const canCreate =
    trimmedSearch !== "" &&
    !options.some((opt) => opt.toLowerCase() === searchLower);

  return { trimmedSearch, filteredOptions, canCreate };
}
